module.exports = __webpack_public_path__ + "media/images/sign-in-3ed491be53482de0f2b637d51204fc88.svg";